<template>
    <router-view />
</template>

<style>

html, body {
  background-color: #F8F8F8;
  font-family: "Raleway";
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

#app {
  width: 1200px;
  height: 2486px;
  margin-inline: auto;
}
</style>
